var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"mb-2"},[_vm._v("Users")]),_c('Datatable',{attrs:{"headers":_vm.headers,"itemsPerPage":15,"items":_vm.users,"is-loading":_vm.isFetchingUsers,"disableFiltering":""},scopedSlots:_vm._u([{key:"roles",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getRoles(item.roles))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }